import { IMenuBadge } from 'graphql/types';

export function isStaticBadge(badge: IMenuBadge) {
    return badge.__typename === 'StaticBadge';
}
